import { Auth } from "../../../Views/Auth/Auth";
import { useAuth } from "./useAuth/useAuth";
import { Login } from "../../../Views/Login/Login";
import { ReactElement } from "react";
import { ProtectedRoute } from "../accessControl/ProtectedRoute/ProtectedRoute";
import { handleLogout } from "../Logout/handleLogout/handleLogout";
import { Logout } from "../Logout/Logout";
import { AuthVersioningProps } from "core/hooks/useAuthVersioning";
import { useNavigate } from "react-router-dom";
import { ClientInfoState } from "shared/core/state/clientInfoState";

const useAuthModules = (): AuthVersioningProps => {
  const auth = useAuth();
  const navigate = useNavigate();

  return {
    auth: (sso?: boolean) => <Auth auth={auth} sso={sso} />,
    Login: () => <Login auth={auth} />,
    Logout: ({ type }: { type?: "default" | "nav" }) => {
      const logout = handleLogout(auth);

      return <Logout type={type} handleLogout={logout} />;
    },
    protect: (el: ReactElement): ReactElement => <ProtectedRoute auth={auth}>{el}</ProtectedRoute>,
    updateClient: () => {
      navigate("/login", { state: "change_org" });
    },
    handleSsoSetup: () => {
      auth.signinRedirect({ redirect_uri: `${window.location.origin}/auth/sso`, extraQueryParams: { client_code: ClientInfoState.getCode() } });
    },
  };
};

export const AuthModulesV1 = (): AuthVersioningProps => {
  const modules = useAuthModules();

  return modules;
};
